export default [
  {
    path: "payments",
    name: "payments",
    component: (): Promise<any> => import(/* webpackChunkName: "payments" */ "@/views/Admin/PaymentsView.vue")
  }
];
